export enum WallTypes {
    GP = 'gp',
    PRO = 'pro',
}
